var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertLispendes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_54)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 60,
    height: 60,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4772 52.1848C73.4772 52.1848 74.0606 52.7681 74.6439 53.9348C74.6439 53.9348 76.4968 51.0181 78.1439 50.4348",
    stroke: "#FF4500",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6607 46.3582C64.7458 46.2348 62.4938 46.5706 62.4938 46.5706C61.0719 46.6722 58.3467 47.4694 58.3468 52.1252C58.3468 56.7415 58.3166 62.4325 58.3468 64.7012C58.3468 66.0873 59.205 69.3205 62.1755 69.4937C65.7862 69.7044 72.2899 69.7492 75.2739 69.4937C76.0727 69.4487 78.7321 68.8216 79.0687 65.9282C79.4174 62.9306 79.348 60.8474 79.348 60.3516",
    stroke: "#FF4500",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6666 52.1848C81.6666 55.4064 79.0524 58.0182 75.8276 58.0182C72.6029 58.0182 69.9887 55.4064 69.9887 52.1848C69.9887 48.9631 72.6029 46.3514 75.8276 46.3514C79.0524 46.3514 81.6666 48.9631 81.6666 52.1848Z",
    stroke: "#FF4500",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1439 59.1848H68.8106",
    stroke: "#FF4500",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1439 63.8516H73.4772",
    stroke: "#FF4500",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_54",
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_54"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_54",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertLispendes);
export default __webpack_public_path__ + "static/media/cert-lispendes.bc007486d455c4d62382254e93185434.svg";
export { ForwardRef as ReactComponent };